import React, { createContext, useContext, useMemo } from 'react';
import Layout from '../../../MainMenu/Layout/Layout';
import ScreenLink from '../../../MainMenu/ScreenLink/ScreenLink';
import NodeCodeComponent from '../NodeCodeComponent';
import RevealCodesContext from '../RevealCodesContext';
var ScreensContext = createContext([]);
function wrapScreenLink(Component) {
  return function (props) {
    var screens = useContext(ScreensContext);
    var screen = useMemo(function () {
      var matches = screens.filter(function (screen) {
        return screen.screenId === props.id;
      });
      return matches.length > 0 ? matches[0] : null;
    }, [props.id, screens]);
    return screen ? /*#__PURE__*/React.createElement(Component, props, /*#__PURE__*/React.createElement(NodeCodeComponent, {
      label: props.name,
      nodeData: screen.nodeData
    })) : null;
  };
}
var ScreenLinkComponent = wrapScreenLink(ScreenLink);
var _toLayoutScreens = function toLayoutScreens(screens, layout) {
  return layout ? layout.map(function (layoutItem) {
    if (layoutItem.type === 'screen') {
      var _screen = screens.filter(function (screen) {
        return screen.screenId === layoutItem.screenId;
      })[0];
      layoutItem.name = _screen.name;
      layoutItem.href = '#';
    }
    if (layoutItem.type === 'group' && layoutItem.children) {
      layoutItem.children = _toLayoutScreens(screens, layoutItem.children);
    }
    return layoutItem;
  }) || [] : [];
};
export default function InstrumentManagementLayout(_ref) {
  var size = _ref.size,
    screens = _ref.screens,
    layout = _ref.layout;
  var revealCodes = useContext(RevealCodesContext);
  var layoutScreens = useMemo(function () {
    return _toLayoutScreens(screens, layout);
  }, [screens, layout]);
  var Component = useMemo(function () {
    return revealCodes ? ScreenLinkComponent : ScreenLink;
  }, [revealCodes]);
  return /*#__PURE__*/React.createElement(ScreensContext.Provider, {
    value: screens
  }, /*#__PURE__*/React.createElement(Layout, {
    size: size,
    screens: layoutScreens,
    ScreenLinkComponent: Component
  }));
}